export default "__VITE_ASSET__807eda89__"